import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import moment from 'moment';
import { Box, Divider, Grid } from '@mui/material';
import Typography from '@atoms/Typography';
import SocialButton from '@atoms/SocialButton';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Spacer from '@atoms/Spacer';

import { useTranslation } from '@app/config/i18n';

// import OrganisationHeader from './OrganisationHeader';
import OrganisationOpportunities from './OrganisationOpportunities';

import {
  Card,
  CardContianer,
  OrgAvatar,
  OrgInfo,
  DetailsContainer,
  LinksContainers,
  LinkItem,
  SocialContainer,
} from './style';

const OrganisationDetails = ({ organisationSlug, organisation }) => {
  const { city } = organisation;
  const { t } = useTranslation('common');

  return (
    <CardContianer>
      <Card>
        <Grid container>
          <Grid item xs={12} sm={8} md={9} lg={9}>
            <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
              <OrgInfo variant="overline">
                {t('member_since')} {moment(organisation.created_at).format('MMMM YYYY')}
              </OrgInfo>
              <Typography gutterBottom variant="h2">
                {organisation.name}
              </Typography>
              <OrgInfo variant="subtitle1">
                <LocationOnIcon fontSize="small" />
                {city.name} ,{city.country && city.country.name}
              </OrgInfo>
              <Spacer height="0.5rem" />
              <Divider />
              {/* <Spacer height="1rem" /> */}
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={3} lg={3}>
            <OrgAvatar width="187px" src={organisation.logo.path} />
            <Spacer height="1rem" />
          </Grid>
        </Grid>
        <DetailsContainer>{organisation.description}</DetailsContainer>
        <Spacer height="1rem" />
        <Typography variant="h5" gutterBottom>
          {t('contact_us')}
        </Typography>
        {/* <Spacer height="1rem" /> */}
        <LinksContainers variant="body2" gutterBottom>
          <LinkItem href={`http://${organisation.website}`}>
            <PublicIcon fontSize="small" />
            <Typography variant="body1">{organisation.website}</Typography>
          </LinkItem>
          <LinkItem href={`mailto:${organisation.email}`}>
            <MailOutlineIcon fontSize="small" />
            <Typography variant="body1">{organisation.email}</Typography>
          </LinkItem>
        </LinksContainers>
        <SocialContainer>
          {organisation.social_links &&
            organisation.social_links.length > 0 &&
            organisation.social_links.map((social) => (
              <>
                <SocialButton url={social.url} type={social.type} />
                <Spacer width="1rem" />
              </>
            ))}
        </SocialContainer>

        <Spacer height="2rem" />
        <Divider />
        <OrganisationOpportunities
          organisationSlug={organisationSlug}
        />
      </Card>
    </CardContianer>
  );
};

OrganisationDetails.propTypes = {
  organisation: PropTypes.object,
  organisationSlug: PropTypes.string.isRequired,
};

OrganisationDetails.defaultProps = {
  organisation: null
};

OrganisationDetails.fragments = {
  organisation: gql`
    fragment organisationDetails on Organisation {
      id
      slug
      name
      email
      description
      website
      social_links {
        url
        type
      }
      user {
        id
      }
      logo {
        name
        path
      }
      cover {
        name
        path
      }
      city {
        name
        country {
          name
        }
      }
      created_at
      account {
        name
        email
        account_id
        # country_code
        business_type
        default_currency
        charges_enabled
        payouts_enabled
        has_external_account
        is_disabled
        disabled_reason
      }
    }
  `,
};

export default OrganisationDetails;
